export const promoListDataLayer = {
  component: {
    PROMO_LIST: 'promo_list',
    PROMO_CAROUSEL: 'promo_carousel',
  },
  categories: {
    VENUE_FORM: 'venue_form',
    VIEW_PROMOTION: 'view_promotion',
    SELECT_PROMOTION: 'select_promotion',
  },
} as const;
